/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './url-slug.reducer';

export const UrlSlugDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const urlSlugEntity = useAppSelector(state => state.urlSlug.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="urlSlugDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.urlSlug.detail.title">UrlSlug</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.urlSlug.id">Id</Translate>
            </span>
          </dt>
          <dd>{urlSlugEntity.id}</dd>
          <dt>
            <span id="slug">
              <Translate contentKey="tinyMedicRestApp.urlSlug.slug">Slug</Translate>
            </span>
          </dt>
          <dd>{urlSlugEntity.slug}</dd>
          <dt>
            <span id="originalUrl">
              <Translate contentKey="tinyMedicRestApp.urlSlug.originalUrl">Original Url</Translate>
            </span>
          </dt>
          <dd>{urlSlugEntity.originalUrl}</dd>
          <dt>
            <span id="createdDate">
              <Translate contentKey="tinyMedicRestApp.urlSlug.createdDate">Created Date</Translate>
            </span>
          </dt>
          <dd>{urlSlugEntity.createdDate}</dd>
          <dt>
            <span id="timeToLive">
              <Translate contentKey="tinyMedicRestApp.urlSlug.timeToLive">Time To Live</Translate>
            </span>
          </dt>
          <dd>{urlSlugEntity.timeToLive}</dd>
          <dt>
            <span id="secret">
              <Translate contentKey="tinyMedicRestApp.urlSlug.secret">Secret</Translate>
            </span>
          </dt>
          <dd>{urlSlugEntity.secret}</dd>
          <dt>
            <span id="createdFor">
              <Translate contentKey="tinyMedicRestApp.urlSlug.createdFor">Created For</Translate>
            </span>
          </dt>
          <dd>{urlSlugEntity.createdFor}</dd>
          <dt>
            <span id="entityType">
              <Translate contentKey="tinyMedicRestApp.urlSlug.entityType">Entity Type</Translate>
            </span>
          </dt>
          <dd>{urlSlugEntity.entityType}</dd>
          <dt>
            <span id="entityId">
              <Translate contentKey="tinyMedicRestApp.urlSlug.entityId">Entity Id</Translate>
            </span>
          </dt>
          <dd>{urlSlugEntity.entityId}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.urlSlug.active">Active</Translate>
            </span>
          </dt>
          <dd>{urlSlugEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.urlSlug.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{urlSlugEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.urlSlug.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{urlSlugEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.urlSlug.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{urlSlugEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.urlSlug.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{urlSlugEntity.timestampEntry}</dd>
        </dl>
        <Button tag={Link} to="/url-slug" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/url-slug/${urlSlugEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default UrlSlugDetail;
